/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Sidebar_DescriptionInputs */

const es_walkthrough_sidebar_description = /** @type {(inputs: Walkthrough_Sidebar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu historial de chats está acá. Podés buscar, renombrar y eliminar conversaciones. Usá Ctrl+B (Cmd+B en Mac) para mostrar u ocultar la barra lateral.`)
};

const en_walkthrough_sidebar_description = /** @type {(inputs: Walkthrough_Sidebar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your chat history lives here. You can search, rename, and delete conversations. Use Ctrl+B (Cmd+B on Mac) to show or hide the sidebar.`)
};

/**
* | output |
* | --- |
* | "Your chat history lives here. You can search, rename, and delete conversations. Use Ctrl+B (Cmd+B on Mac) to show or hide the sidebar." |
*
* @param {Walkthrough_Sidebar_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_sidebar_description = /** @type {((inputs?: Walkthrough_Sidebar_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Sidebar_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_sidebar_description(inputs)
	return en_walkthrough_sidebar_description(inputs)
});
export { walkthrough_sidebar_description as "walkthrough.sidebar_description" }